import { useMemo } from 'react'

import { buildBreadcrumbs } from '@/lib/github/fetch'
import type { TutorialSection } from '@/shared/components/TutorialSidebar'

export function useSectionBreadcrumbs(
  sections: TutorialSection[],
  currentSectionPath: string | undefined,
  rootLabel?: string
) {
  return useMemo(() => {
    if (!currentSectionPath) return undefined
    const section = sections.find((s) => s.path === currentSectionPath)
    return section ? buildBreadcrumbs(section, rootLabel) : undefined
  }, [currentSectionPath, sections, rootLabel])
}
